import { NgFor } from "@angular/common";
import { Component } from "@angular/core";
import { TabViewModule } from "primeng-v17/tabview";
import { SafePipe } from "../../../../shared/pipes/safe.pipe";
import { TranslateDirective } from "../../../../shared/transloco/translate.directive";
import { NewUiTcConsentViewComponent } from "./new-ui-tc-consent-view.component";

@Component({
  selector: "app-tc-consent-view",
  templateUrl: "./tc-consent-view.component.html",
  imports: [TranslateDirective, TabViewModule, NgFor, SafePipe],
})
export class TcConsentViewComponent extends NewUiTcConsentViewComponent {}
